export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl"></div>
      <div className="absolute bottom-0 left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>

      <div className="relative w-full px-6 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-6 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              <span>每日更新 · 热门综艺一网打尽</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              红桃影院 · 综艺在线观看
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-5">
              热门综艺真人秀免费看，每日欢乐不停
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              红桃影院是国内领先的综艺在线观看平台，收录数千部热门综艺、真人秀、搞笑综艺等精彩内容。
              每日更新热门综艺超过50期，高清流畅不缓冲，支持手机电脑多终端同步观看。
              无论是最新综艺还是经典回顾，综艺大全尽在红桃影院，随时随地免费看，让欢乐触手可及。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">3000+</div>
                <div className="text-xs text-foreground-500 mt-1">综艺资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">日均更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-500">1080P</div>
                <div className="text-xs text-foreground-500 mt-1">超清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观看
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-700 font-semibold rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-bar-chart-line mr-2"></i>
                综艺热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-lg">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20variety%20show%20TV%20studio%20with%20colorful%20stage%20lights%20and%20LED%20screens%20showing%20entertainment%20content%2C%20warm%20golden%20and%20peach%20tones%2C%20modern%20entertainment%20atmosphere%2C%20dynamic%20stage%20design%2C%20professional%20studio%20photography%2C%20bright%20vibrant%20colors&width=800&height=600&seq=hero-main&orientation=landscape"
                  alt="红桃影院 - 综艺在线观看平台"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 rounded-xl bg-accent-500 flex items-center justify-center shadow-sm animate-float">
                <div className="text-center text-white">
                  <i className="ri-hd-line text-2xl block mb-1"></i>
                  <span className="text-xs font-bold block">高清</span>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 w-20 h-20 rounded-xl bg-primary-500 flex items-center justify-center shadow-sm animate-float" style={{ animationDelay: '0.5s' }}>
                <div className="text-center text-white">
                  <i className="ri-vip-crown-line text-xl block mb-1"></i>
                  <span className="text-xs font-bold block">免费</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}